/* eslint-disable */
import * as Types from '../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateCommentMutationVariables = Types.Exact<{
  storyId: Types.Scalars['String'];
  comment: Types.Scalars['String'];
  project_id: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type CreateCommentMutation = { __typename: 'Mutation', createComment: { __typename: 'Comment', id: string, text: string, created_at: string, argument_id: number } };


export const CreateCommentDocument = gql`
    mutation createComment($storyId: String!, $comment: String!, $project_id: String) {
  createComment(argument_id: $storyId, text: $comment, campaign_id: $project_id) {
    id
    text
    created_at
    argument_id
  }
}
    `;
export type CreateCommentMutationFn = Apollo.MutationFunction<CreateCommentMutation, CreateCommentMutationVariables>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      storyId: // value for 'storyId'
 *      comment: // value for 'comment'
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useCreateCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentMutation, CreateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, options);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<CreateCommentMutation, CreateCommentMutationVariables>;